
(function () {

	'use strict';


	let cologicSortByTags = {

		initSortByTags: function () {

			// let that = this;
            //
			// this.showToTop();
			// this.setBurger();
			// this.enableAccordion();
			// // this.navigationHandling();
			// // this.setYoutubeBox();
            //
			// $('.toTopWrapper').click(this.pageToTop);
			// // $(window).scroll(function () {
			// // 	that.setBackgroundImages();
			// // 	that.showToTop();
			// // });
			// // setTimeout(function () {
			// // 	that.setBackgroundImages()
			// // }, 1500);
            //
			// this.equalHeight();

		},


        // identifyDataTags: function (_classes) {
        //     if (typeof(_classes) != 'undefined' && _classes != null && _classes !== ''){
        //         let dataTags = [];
        //         _classes.forEach((_class)=>{
        //             $(_class).each(function(){
        //                 let json_data = $(this).data();
        //                 for(let i in json_data){
        //                     if(typeof(dataTags[i]) != 'undefined'){
        //                         dataTags[i].push(json_data [i].trim().split(' '));
        //                     }else{
        //                         dataTags[i] = [];
        //                         dataTags[i].push(json_data [i].trim().split(' '));
        //                     }
        //                 }
        //             });
        //         });
        //         return dataTags;
        //     }else{
        //         return [];
        //     }
		// },

        identifyDataTags: function (_classes, parentElement = '.crawlContainer ') {
            if (typeof(_classes) != 'undefined' && _classes != null && _classes !== ''){
                let dataTags = [];
                _classes.forEach((_class)=>{
                    // console.log($('.' +_class));
                    $(parentElement +' .'+_class).each(function(){
                        let json_data = $(this).data();
                        // console.log(json_data);

                        for(let i in json_data){
                            if(typeof(dataTags[i]) != 'undefined'){
                                dataTags[i].push(String(json_data[i]).trim().split(' '));
                            }else{
                                dataTags[i] = [];
                                // console.log(json_data[i]);
                                dataTags[i].push(String(json_data[i]).trim().split(' '));
                            }
                        }
                    });
                });
                // console.log(dataTags);
                return dataTags;
            }else{
                return [];
            }
        },


        // enableTagButtonsForDataTags: function (_dataTags) {
        //     let out = '';
        //     // out += '<h3 class="tagSectionHead">Aktuelle Kategorien (zum ein-/ausblenden klicken)</h3>';
        //     out += '<div class="tagSection pt-2">';
        //     let procArray = [];
        //     for(let i in _dataTags){
        //         procArray[i] = [];
        //         // console.log(i);
        //         // console.log(_dataTags[i]);
        //         // console.log(_dataTags[i]);
        //         // if(_dataTags[i][0] != ''){
        //             _dataTags[i].forEach((selectTag) =>{
        //                 // console.log(selectTag);
        //                     selectTag.forEach((tag) => {
        //                         if(typeof(procArray[i][tag]) == 'undefined') {
        //                             if(tag != ''){
        //                                 procArray[i][tag] = 1;
        //                                 let fineTag = tag.charAt(0).toUpperCase()  + tag.slice(1)
        //                                 out += '<div class="btn tagBtn active" data-wert="' + tag + '" data-kategorie="' + i + '">' + fineTag + '</div>';
        //                             }
        //                         }
        //                     });
        //             });
        //             // out += '</div>';
        //         // }
        //     }
        //     out += '</div>';
        //     $('.crawlContainer ').prepend(out);
        //     // if (typeof(_dataTags) != 'undefined' && _dataTags != null && _dataTags !== '' && _dataTags.length > 0){
        //     //     _dataTags.forEach((_dataTag)=>{
        //     //         console.log(_dataTag);
        //     //     });
        //     // }
        //     $('.tagBtn').each(function (){
        //         $(this).bind('click', function(){
        //             let that = this;
        //             $('.tagBtn').each(function (){
        //                 if(!$(this).hasClass('active')){
        //                     let kategorie = $(this).data('kategorie');
        //                     let wert = $(this).data('wert');
        //                     let found = false;
        //                     $('.probo').each(function(){
        //                         if($(this).data(kategorie).indexOf(wert) != -1){
        //                             // $(this).toggleClass(kategorie);
        //                             // $(this).toggleClass(wert);
        //                             $(this).parent().parent().removeClass('active');
        //                         }
        //                     });
        //                 }
        //
        //             });
        //             let kategorie = $(this).data('kategorie');
        //             let wert = $(this).data('wert');
        //             let found = false;
        //             $('.probo').each(function(){
        //                 if($(this).data(kategorie).indexOf(wert) != -1){
        //                     found = true;
        //                     // $(this).toggleClass(kategorie);
        //                     // $(this).toggleClass(wert);
        //                     if($(that).hasClass('active')) {
        //                         $(this).parent().parent().removeClass('active');
        //                     }else{
        //                         $(this).parent().parent().addClass('active');
        //                     }
        //                 }
        //             });
        //             if(found){
        //                 $(this).toggleClass('active');
        //             }
        //
        //
        //
        //         })
        //     });
		// },
        //



        enableTagButtonsForDataTags: function (_dataTags, parentElement = '.crawlContainer ') {
            // console.log(_dataTags);
            // console.log(parentElement);
            let out = '';
            // out += '<h3 class="tagSectionHead">Aktuelle Kategorien (zum ein-/ausblenden klicken)</h3>';
            let procArray = [];

            for(let i in _dataTags){
                if(i == 'kategorie'){
                    procArray[i] = [];
                    let tempout1 = '';
                    let tempout2 = '';
                    let tempout3 = '';
                    let tempout4 = '';
                    let tempout5 = '';
                    let tempout6 = '';
                    let tempout7 = '';
                    out += '<select id="kategorieFilter" class="kategorieFilter" >';
                    out += '<option value="all">Alle Einblicke</option>';

                    _dataTags[i].forEach((selectTag) =>{
                        // console.log(i);

                        selectTag.forEach((tag) => {
                            if(typeof(procArray[i][tag]) == 'undefined') {
                                if(tag != ''){
                                    procArray[i][tag] = 1;
                                    let fineTag = tag.charAt(0).toUpperCase()  + tag.slice(1);
                                    fineTag = fineTag.replaceAll('_',' ',);
                                    fineTag = fineTag.replaceAll('-',' ',);
                                    switch(tag){
                                        case 'ganz-klassisch':
                                            tempout1 = '<option value="' + tag + '">' + fineTag + '</option>';
                                            break;
                                        case 'cool-und-edel':
                                            tempout2 = '<option value="' + tag + '">' + fineTag + '</option>';
                                            break;
                                        case 'mit-stil':
                                            tempout3 = '<option value="' + tag + '">' + fineTag + '</option>';
                                            break;
                                        case 'neu-in-alter-pracht':
                                            tempout4 = '<option value="' + tag + '">' + fineTag + '</option>';
                                            break;
                                        case 'ganz-einfach-glatt':
                                            tempout5 = '<option value="' + tag + '">' + fineTag + '</option>';
                                            break;
                                        case 'besondere':
                                            tempout6 = '<option value="' + tag + '">' + fineTag + '</option>';
                                            break;
                                        default:
                                            tempout7 += '<option value="' + tag + '">' + fineTag + '</option>';
                                            break;
                                    }
                                    // out += '<option value="' + tag + '">' + fineTag + '</option>';

                                }
                            }
                        });
                    });
                    out += tempout1;
                    out += tempout2;
                    out += tempout3;
                    out += tempout4;
                    out += tempout5;
                    out += tempout6;
                    out += tempout7;

                    out += '</select>';


                }
            }


            // console.log('parent:');
            // console.log($(parentElement));
            $(parentElement + ' .crawlInner .katfil').html(out);
            setTimeout(function () {
                $('.kategorieFilter').selectpicker({
                    multiple: false,
                    dropupAuto: false,
                    // maxOptions: 1,
                }).on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
                    console.log('closePicker! 1')
                    $(this).selectpicker('toggle');                });

            },100);

            setTimeout(function () {
                $(parentElement + ' #kategorieFilter').bind('change', function (){
                    let that = this;
                    let kategorie = 'kategorie';
                    let wert = $(this).val();
                    // console.log(wert);
                    // if(wert == 'all'){
                    //     $(parentElement + ' .blog').parent().addClass('active');
                    // }
                    $(parentElement + ' .teaser').each(function(){
                        if($(this).data(kategorie).indexOf(wert) != -1 || wert == 'all'){
                            $(this).parent().addClass('active');
                        }else{
                            $(this).parent().removeClass('active');

                        }
                    });

                    // $('.teaser').removeClass('c-elem');
                    $(parentElement + ' .teaser').removeClass('c-elem');

                });
            },200);




        },


        sortByDataTag: function(_parent, _item, _tag, _order) {
            switch(_order){
                case "asc":
                    $(_parent+' '+_item).sort(sort_up).appendTo(_parent);
                    break;
                case "desc":
                    $(_parent+' '+_item).sort(sort_down).appendTo(_parent);
                    break;
            }

            function sort_up(a, b) {
                return ($(b).data(_tag)) < ($(a).data(_tag)) ? 1 : -1;
            }

            function sort_down(a, b) {
                return ($(b).data(_tag)) > ($(a).data(_tag)) ? 1 : -1;
            }
        },




    };

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicSortByTags);
}());
